import { useQuery } from "@tanstack/react-query";
import {
  getRequestContractQueryOptions,
  mapDimCodeNameToSelectOption,
} from "./getRequestContractQueryOptions";

const useGetRequestContractShipTos = (
  cardCode: string | undefined,
  itemCode: string | undefined
) =>
  useQuery({
    ...getRequestContractQueryOptions(cardCode, itemCode),
    enabled: cardCode !== undefined && itemCode !== undefined,
    select: ({ data }) =>
      data?.ShipToAddresses?.map(mapDimCodeNameToSelectOption),
  });

export default useGetRequestContractShipTos;
